import React from 'react';
import { Mutation } from 'react-apollo';
import Propagator from '../../Propagator';
import gql from 'graphql-tag';

const SET_CASH_DECISION = gql`
	mutation($gameID: ID!, $value: String) {
		setCashDecision(gameID: $gameID, value: $value) @client{
			id
			data
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={SET_CASH_DECISION}>
		{setCashDecision => Propagator(children, setCashDecision)}
	</Mutation>
);
